import { render, staticRenderFns } from "./profit-config.vue?vue&type=template&id=27d1b368&scoped=true"
import script from "./profit-config.vue?vue&type=script&lang=js"
export * from "./profit-config.vue?vue&type=script&lang=js"
import style0 from "./profit-config.vue?vue&type=style&index=0&id=27d1b368&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1b368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d1b368')) {
      api.createRecord('27d1b368', component.options)
    } else {
      api.reload('27d1b368', component.options)
    }
    module.hot.accept("./profit-config.vue?vue&type=template&id=27d1b368&scoped=true", function () {
      api.rerender('27d1b368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/profit-config.vue"
export default component.exports